import { ShaderProgram } from './ShaderProgram';
import { RenderDevice } from './RenderDevice';
import { ShaderSource } from './ShaderSource';
import { Resource } from './Resource';

export class ShaderResource extends Resource<ShaderSource> {
  static readonly TypeId: string = 'shader';
  private readonly _renderDevice: RenderDevice;

  constructor(renderDevice: RenderDevice, id: string) {
    super(id);
    this._renderDevice = renderDevice;
  }

  get typeId(): string {
    return ShaderResource.TypeId;
  }

  compile(defines: string[]): ShaderProgram | null {
    console.log(`ShaderResource compiling shader ${defines}`);
    return this._renderDevice.createShaderProgram(
      this.data!.vertex!.data!,
      this.data!.fragment!.data!,
      defines
    );
  }
}
